import { mdiKey } from '@mdi/js'

import ShareLevel from '../../constants/Day6ShareLevel'

const getShareIcon = shareLevel => {
  switch (shareLevel) {
    case ShareLevel.NONE:
      return 'remove'
    case ShareLevel.PRIVATE:
      return 'lock'
    case ShareLevel.VERSIONS:
      return 'content_copy'
    case ShareLevel.PUBLIC:
      return mdiKey
    default:
      return 'pending'
  }
}

export {
  getShareIcon
}
